export const NAMESPACE = 'billing';
export const ROUTE_PARENT_SECTION = 'billing';
export const ROUTE_SECTION_ACCOUNT = 'my-account';
export const ROUTE_SECTION_PURCHASE = 'purchase';

// BILLING "MY ACCOUNT" TABS:
export const TAB_CURRENT_PLAN = 'current-plan';
export const TAB_BILLING_INFO = 'billing-information';
export const TAB_INVOICES = 'invoices';
export const TAB_NAMES = [TAB_CURRENT_PLAN, TAB_BILLING_INFO, TAB_INVOICES];

// BILLING "PURCHASE WIZARD" STEPS:
export const PURCHASE_STEP_PAYMENT = 'payment';
export const PURCHASE_STEP_OVERVIEW = 'overview';
export const PURCHASE_STEP_SUCCESS = 'success';
export const CANCELLATION_STEP_SUCCESS = 'success';
export const PURCHASE_STEP_CANCELLATION_OVERVIEW = 'cancellation';
export const WIZARD_STEPS = [
  PURCHASE_STEP_PAYMENT, PURCHASE_STEP_OVERVIEW, PURCHASE_STEP_SUCCESS,
];

export const COUNTRIES_ZIP_MANDATORY = ['US', 'CA'];

export const RECURLY_JS_CONFIGURATION = {
  fields: {
    all: {
      style: {
        fontFamily: 'Proxima+Nova',
        fontSize: '14px',
        fontColor: '#1395f0',
        fontWeight: '400',
      },
    },
  },
};

export const VIRTUAL_CLOUD_DEVICE_LABEL = 'Virtual Cloud';
export const REAL_DEVICE_LABEL = 'Real Device Cloud';

export const VIRTUAL_DEVICE = 'virtual';
export const REAL_DEVICE = 'real';

export const MONTH_INTERVAL_UNIT = 'month';
export const YEAR_INTERVAL_UNIT = 'year';

export const LIVE_COVERAGE = 'live';
export const AUTOMATED_LIVE_COVERAGE = 'automated_live';

export const LIVE_COVERAGE_LABEL = 'Live Only';
export const AUTOMATED_LIVE_COVERAGE_LABEL = 'Automated + Live';

export const ACTIVE_SUBSCRIPTION_STATE = 'active';
export const CANCELED_SUBSCRIPTION_STATE = 'canceled';

// BILLING "SUCCESS" MESSAGES:
export const SUCCESS_STEP_TITLE_SUCCESS = 'Success';
export const SUCCESS_STEP_TITLE_CANCEL = '{device_type} Subscription Canceled!';
export const SUCCESS_STEP_DESC_LEVEL_UP = 'You’ve just leveled up! You have successfully updated your Sauce Labs coverage! Please check your email for confirmation of your plan changes.';
export const SUCCESS_STEP_DESC_UPDATED_COVERAGE = 'You have successfully updated your Sauce Labs coverage! Please check your email for confirmation of your plan changes.';
export const SUCCESS_STEP_DESC_CANCEL = 'We’re sorry to see you go! Cancellations take place at the end of the billing cycle. You may continue to use Sauce Labs until {billing_cycle_date}. Your account will remain in read-only mode after cancellation. Thanks for being a Sauce Labs customer. If there is anything we can do to help, please give us a call at: 1-855-677-0011';

// SUCCESS TYPES VALUES
export const NEW_PURCHASE = 'new purchase';
export const UPGRADE = 'upgrade';
export const DOWNGRADE = 'downgrade';
export const LEGACY = 'legacy';
export const CANCEL = 'cancel';

// SUCCESS TYPES
export const SUCCESS_TYPES = [
  NEW_PURCHASE,
  UPGRADE,
  DOWNGRADE,
  LEGACY,
  CANCEL,
];

export const DATE_FORMAT = 'MMMM d, y';

export const MOMENT_FORMAT_DAY_MONTH_YEAR = 'LL';

export const MOMENT_FORMAT_ORDINAL_DAY_OF_MONTH = 'Do';

export const PENDING_INVOICE_STATE = 'pending';
export const PROCESSING_INVOICE_STATE = 'processing';
export const PAST_DUE_INVOICE_STATE = 'past_due';
export const PAID_INVOICE_STATE = 'paid';
export const FAILED_INVOICE_STATE = 'failed';

export const SUCCESS_FLYING_IMAGE_WIDTH = 498;
export const SUCCESS_FLYING_IMAGE_HEIGHT = 353;
export const SUCCESS_CANCEL_IMAGE_WIDTH = 230;
export const SUCCESS_CANCEL_IMAGE_HEIGHT = 375;
export const SUCCESS_ADJUSTING_IMAGE_WIDTH = 299;
export const SUCCESS_ADJUSTING_IMAGE_HEIGHT = 382;

export const INVALID_ADDRESS_ERROR_TYPE = 'invalid_address';
